import { select, put, call, takeEvery } from "redux-saga/effects";
import { fetchImage } from 'utils/images/imageManager';

// Redux States
import { 
  ADD_IMAGES_TO_MAP,
  FETCH_MISSING_IMAGES
} from "./actionTypes"

function* fetchMissingImagesSaga(filenames = [], size = 'original') {
  const imageMap = yield select(state => state.imageMap);

  const newImages = {};
  for (const filename of filenames) {
    if (!filename || imageMap[filename]) continue;

    try {
      const { blob } = yield call(fetchImage, filename, size);
      const objectUrl = URL.createObjectURL(blob); // ← only here
      newImages[filename] = objectUrl;
    } catch (e) {
      console.error("Image load failed:", filename, e);
    }
  }

  if (Object.keys(newImages).length > 0) {
    yield put({ type: 'ADD_IMAGES_TO_MAP', payload: newImages });
  }
}

function* imageMapSaga() {
  yield takeEvery(FETCH_MISSING_IMAGES, function* (action) {
    const { filenames, size = 'original' } = action.payload || {};
    yield call(fetchMissingImagesSaga, filenames, size);
  });
}

export default imageMapSaga;
